module.exports = __webpack_public_path__ + "img/comochegar01.e32def0c.jpg";